import * as React from "react";

function PrintIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={25} fill="none" {...props}>
      <path
        d="M18 7.5H6v-4h12v4zm0 5.5c.283 0 .52-.096.712-.288A.965.965 0 0019 12a.968.968 0 00-.288-.713A.967.967 0 0018 11a.967.967 0 00-.712.287A.968.968 0 0017 12c0 .283.096.52.288.712A.965.965 0 0018 13zm-2 6.5v-4H8v4h8zm2 2H6v-4H2v-6c0-.85.292-1.562.875-2.137S4.167 8.5 5 8.5h14c.85 0 1.563.288 2.138.863S22 10.65 22 11.5v6h-4v4z"
        fill="#2F3A49"
      />
    </svg>
  );
}

const MemoPrintIcon = React.memo(PrintIcon);
export default MemoPrintIcon;
